import React from 'react';
import { useReservationInvoicesLookupQuery } from '../../Reservation/Service/reservationInvoicesLookupApi';
import type { BookingReservationInvoiceLookup } from '../Types/bookingReservationTable.types';
import { mapBookingReservationInvoicesLookup } from './bookingReservationInvoicesLookupApi.contract';

export const useBookingReservationInvoicesLookupQuery = (
  reservationId?: number
): {
  invoices: BookingReservationInvoiceLookup[];
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  errorMessage?: string;
} => {
  const queryResult = useReservationInvoicesLookupQuery(reservationId);

  const invoices = React.useMemo(
    () => mapBookingReservationInvoicesLookup(queryResult.invoices),
    [queryResult.invoices]
  );

  return {
    invoices,
    isLoading: queryResult.isLoading,
    isError: queryResult.isError,
    error: queryResult.error,
    errorMessage: queryResult.errorMessage,
  };
};
